import React, { Component } from 'react';
import elementResizeEvent from 'element-resize-event';

export default function withTableFitDimensions(TableComponent) {
    return class TableFitDimensions extends Component {
        element;
        container;

        state = {
            height: 300
        };

        componentDidMount() {
            this.container = this.element.parentElement.parentElement;
            elementResizeEvent(this.container, this.handleResize);
            this.handleResize();
        }

        componentWillUnmount() {
            elementResizeEvent.unbind(this.container);
        }

        handleResize = () => {
            if (this.container && this.isStateChanged()) {
                this.setState({
                    height: this.container.offsetHeight
                });
            }
        }

        isStateChanged = () => {
            return this.container.offsetHeight !== this.state.height;
        }

        render() {
            return (
                <div className={'react-table-fit'} ref={node => this.element = node}>
                    <TableComponent {...this.props} height={this.state.height} />
                </div>
            );
        }
    };
}
